import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/useReveal";

const links = [
    { label: "CEO's AiChat", href: "#ceo-aichat" },
    { label: "Problem", href: "#problem" },
    { label: "Solution", href: "#solution" },
    { label: "Agents", href: "#agents" },
    { label: "Money Meter", href: "#money-meter" },
    { label: "Scan AI", href: "#scan-ai" },
];

export default function Navbar({ onOpenDemo }) {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled ? "py-2" : "py-4"
            }`}
        >
            <nav
                className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 transition-all duration-500`}
            >
                <div
                    className={`glass-strong rounded-full flex items-center justify-between pl-3 pr-3 sm:pl-5 sm:pr-2 h-14 sm:h-16 transition-all duration-500`}
                >
                    <a
                        href="#top"
                        data-testid="nav-logo"
                        className="flex items-center gap-2.5 group"
                    >
                        <img
                            src={LOGO_URL}
                            alt="CEO's GPT"
                            className="logo-blend h-9 w-9 sm:h-10 sm:w-10 object-contain transition-transform duration-500 group-hover:rotate-[-6deg]"
                            style={{
                                filter: "drop-shadow(0 4px 10px rgba(139,92,246,0.35))",
                            }}
                        />
                        <span className="font-display text-[17px] sm:text-[18px] font-medium tracking-tight text-black">
                            CEO<span className="text-neutral-500">’s</span>{" "}
                            <span className="italic">GPT</span>
                        </span>
                    </a>

                    <div className="hidden md:flex items-center gap-1 text-sm text-neutral-600">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="px-3 py-2 rounded-full hover:text-black hover:bg-black/[0.04] transition-colors"
                            >
                                {l.label}
                            </a>
                        ))}
                    </div>

                    <div className="flex items-center gap-1 sm:gap-2">
                        <Link
                            to="/login"
                            data-testid="nav-login-btn"
                            className="hidden sm:inline-flex items-center text-sm px-4 py-2 rounded-full text-neutral-700 hover:text-black hover:bg-black/[0.04] transition-colors"
                        >
                            Login
                        </Link>
                        <a
                            href="#subscribe"
                            data-testid="nav-subscribe-btn"
                            className="inline-flex items-center gap-1.5 text-sm font-medium bg-black text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-full hover:bg-neutral-800 transition-all hover:shadow-[0_10px_30px_-10px_rgba(139,92,246,0.5)]"
                        >
                            Subscribe
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M5 12h14M13 5l7 7-7 7"
                                    stroke="currentColor"
                                    strokeWidth="1.75"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </a>
                        <button
                            className="md:hidden ml-1 p-2 rounded-full hover:bg-black/[0.04]"
                            onClick={() => setOpen((v) => !v)}
                            data-testid="nav-mobile-toggle"
                            aria-label="Menu"
                        >
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M4 7h16M4 12h16M4 17h16"
                                    stroke="currentColor"
                                    strokeWidth="1.75"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>

                {open && (
                    <div
                        data-testid="nav-mobile-menu"
                        className="md:hidden mt-2 glass-strong rounded-3xl p-3 flex flex-col text-sm"
                    >
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="px-4 py-3 rounded-2xl hover:bg-black/[0.04]"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#subscribe"
                            onClick={() => setOpen(false)}
                            data-testid="nav-mobile-subscribe"
                            className="mt-1 px-4 py-3 rounded-2xl bg-black text-white text-center font-medium"
                        >
                            Subscribe
                        </a>
                    </div>
                )}
            </nav>
        </header>
    );
}
